import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LinksComponent} from '../links.component'
//Services
import {LinkService} from 'src/app/core/services/parameters/link.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditarLinkModal implements OnInit {

  editLinkForm: FormGroup;
  loading = false;
  showAlert = false;
  linkId;
  linkData = {
    id: '',
    createdAt: ''
  };

  constructor(
    public dialogRef: MatDialogRef<LinksComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private linkService: LinkService
  ) {
  }

  ngOnInit(): void {
    this.editLinkForm = this.fb.group({
      name: [, Validators.required],
      link: [, Validators.required]
    })
    this.linkId = this.data.id;
    this.linkService.getLinkById(this.linkId).subscribe(_res => {
      this.linkData = _res;
      this.editLinkForm.patchValue({
        name: _res.name,
        link: _res.link
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editLinkForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editLinkForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.name,
        link: form.value.link
      }
      this.linkService.updateLink(this.linkId, data).subscribe(_res => {
        this.alert.setNotice('Link actualizado correctamente', 'success');
        this.showAlert = true;
            this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo actualizar el link', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
